import * as React from "react";

export class SVMLogo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <img src={require('../../images/silvermouse_login.gif')} alt='Silvermouse logo' />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/SVMLogo.js